import { IoCallOutline, IoLocationOutline } from "react-icons/io5";
import { MdOutlineAlternateEmail } from "react-icons/md";
import { SiTrainerroad } from "react-icons/si";
import { IoLogoDesignernews } from "react-icons/io5";
import { MdOutlineBrandingWatermark } from "react-icons/md";

export const services = [
  {
    id: 1,
    name: "Design and printing solutions.",
    icon: <IoLogoDesignernews />,
    description: `We have highly experienced team of creative designers using state-of-the-art technology to create visual content, which includes branding, layouts, and illustrations by conceptualizing ideas, planning visual strategies, and crafting materials that communicate a message effectively.`,
  },
  {
    id: 2,
    name: "Branding and corporate identity",
    icon: <MdOutlineBrandingWatermark />,
    description: `We offer customized Branding on Corporate and individual Items. Which includes logos, color palettes, typography, and other graphic elements, to brings out the overall image of a corporation by encopassing everything from the design of the company’s website and stationary to the internal culture and communication style.`,
  },
  {
    id: 3,
    name: "Branding Training",
    icon: <SiTrainerroad />,
    description: `We offer Branding training in different courses eg. printing and entrepreneurship. With the aim of empowering individuals or teams with the ability to develop a compelling brand, maintain consistency in branding elements, and leverage the brand as a strategic asset in various market contexts.`,
  },
];

export const contacts = [
  {
    name: "Email",
    value: "walterkagwima@gmail.com",
    icon: <MdOutlineAlternateEmail />,
  },
  {
    name: "Phone Number",
    value: "+254 746231553",
    icon: <IoCallOutline />,
  },
  {
    name: "Address",
    value: "Fiji, Nairobi, Kenya",
    icon: <IoLocationOutline />,
  },
];

export const footer = [
  { name: "Home", to: "header" },
  { name: "About", to: "about" },
  { name: "Services", to: "services" },
  { name: "Products", to: "products" },
  { name: "Clients", to: "clients" },
];
